import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CartServiceService } from 'src/app/services/cart-service.service';
import { HttpService } from 'src/app/services/http.service';
import { PasarelaPagoComponent } from '../vista-compra/components-compra/pasarela-pago/pasarela-pago.component';
import { UiServices } from 'src/app/services/ui-services';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { OperatorsComponent } from './components/operators/operators.component';
import { TranslateService } from '@ngx-translate/core';
import { IonContent, NavController } from '@ionic/angular';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.page.html',
  styleUrls: ['./calendar.page.scss'],
})
export class CalendarPage implements OnInit {
  @ViewChild('ionContent') ionContent: IonContent;
  @ViewChild('operators') operators: OperatorsComponent;
  public service = undefined;
  public operator = undefined;
  public date = undefined;
  public meeting: any[] = [];
  public serviceId = this.route.snapshot.paramMap.get('id');
  public blockedTurns = [];
  public length = true;
  public minLength = false;
  private _meetingId: number;

  constructor(
    private httpSv: HttpService,
    private cartSv: CartServiceService,
    private route: ActivatedRoute,
    private _location: Location,
    private _uiSv: UiServices,
    private _paramSv: ParamServicesService,
    private _trSv: TranslateService,
    private _navCtrl: NavController
  ) {}

  ngOnInit() {
    this.route.queryParamMap.subscribe((params) => {
      const meetingId = params.get('meetingId');
      this._meetingId = +meetingId;
    });

    this.getService();
  }

  async getService() {
    this.service = await this.httpSv.getProduct(this.serviceId, 'services');
  }

  setOperator(data) {
    if (document.body.offsetWidth > 768) {
      this.ionContent.scrollToTop(400);
    }
    this.length = data.length;
    this.minLength = data.minLength < 2 ? false : true;
    this.operator = data.operator;
    if (data.date) {
      this.date = { data: data.date, actualDate: data.actualDate };
      const blockTurns: any[] = data.date.blockTurns;
      blockTurns.forEach((item) => {
        const data = new Date(item.init);
        item.date = `${this.normalizeNumber(
          data.getMonth() + 1
        )}/${this.normalizeNumber(data.getDate())}/${data.getFullYear()}`;
        item.startHour = item.init.split('T')[1];
        item.endHour = item.end.split('T')[1];
        item.title = 'Fuera de servicio';
        item.class = 'out-of-service';
      });
      const dataMeet = this.date.data;
      dataMeet.meeting?.forEach((item) => {
        const splitedDate = item.date.split('/');
        item.date = `${this.normalizeNumber(
          +splitedDate[1]
        )}/${this.normalizeNumber(+splitedDate[0])}/${+splitedDate[2]}`;
      });
      const meetArr = dataMeet.meeting || [];
      meetArr.push(...blockTurns);
      this.meeting = meetArr.filter((item) => +item.id !== this._meetingId);
    }
  }

  normalizeNumber(number: number) {
    return Number(number) < 10 ? `0${number}` : number;
  }

  async sendData(body) {
    try {
      const action = this._meetingId ? 'update' : 'store';

      if (this._meetingId) {
        body.id = this._meetingId;
      }

      await this._uiSv.showLoading();
      const res = await this.httpSv.itemAction(body, 'meeting', action);
      await this._uiSv.loading.dismiss();
      const data = res.data;
      data.price = this.service.promotionalPrice || this.service.price;
      data.name = this.service.name;
      data.presentation = this.service.presentation;
      data.description = this.service.description;
      data.quantity = 1;
      data.meetingId = data.id;
      delete data.id;

      await this._uiSv.showLoading();
      const serviceCart: any[] = await this.cartSv.agendDate(data);
      await this._uiSv.loading.dismiss();
      /** ACTUALIZAR EL MEETING SI EXISTE UN MEETING ID EN LA URL */
      if (this._meetingId) {
        await this._uiSv.presentAlert(
          'Se ha actualizado la fecha de la cita.',
          false
        );
        await this._navCtrl.navigateRoot(`/meeting/${body.serviceId}`, {
          replaceUrl: true,
        });
        await this.getService();
        await this.operators.getOperators();
      } else {
        const resPayment = await this._uiSv.showModal(
          PasarelaPagoComponent,
          {
            total: serviceCart.reduce((prev, next) => {
              prev += next.price * next.quantity;
              return prev;
            }, 0),
            list: serviceCart,
            paramDispatch: this._paramSv.dispatch,
            isService: true,
          },
          'pasarela-pago',
          false
        );
        if (resPayment?.data?.text === 'sended') {
          const sendedTxt = this._trSv.instant(
            'SE_HA_REGISTRADO_EL_PAGO_CON_EXITO_SU_AGENDA_SERA_VERIFICADA_POR_EL_ADMINISTRADOR_DE_LA_PAGINA'
          );
          await this._uiSv.presentAlert(sendedTxt, false);
          await this.getService();
          await this.operators.getOperators();
          await this._navCtrl.navigateBack('/home');
        } else {
          const item = serviceCart[0];
          const id = item.id || item.meetingId;
          const cartId = item.cartId;
          const branchContactId = this.cartSv.selectedBranchId || 0;
          await this.httpSv.itemAction(
            { id, cartId, branchContactId },
            'cart',
            'destroy'
          );
          const txt = this._trSv.instant('SE_HA_CANCELADO_LA_AGENDA');
          await this._uiSv.presentAlert(txt, false);
          await this.cartSv.compareCart(false);
          await this.httpSv.itemAction(
            { meetingId: data.meetingId },
            'meeting',
            'declined'
          );
        }
      }

      if (this.minLength) {
        this.operator = false;
        if (this.operators) {
          this.operators.operator = false;
        }
      }
      // await this.navCtrl.navigateRoot('cart');
    } catch (err) {
      console.error(err);
      const msgErr = err.error.errors[0].message;
      if (msgErr === 'E_UNAUTHORIZED_ACCESS: Unauthorized access') {
        await this._uiSv.loading?.dismiss();
        const content = this._trSv.instant(
          'DEBES_INICIAR_SESION_PARA_CONTINUAR'
        );
        const { role } = await this._uiSv.presentAlert(
          content,
          false,
          'ACEPTAR',
          false
        );
        if (role === 'accept') {
          await this._navCtrl.navigateRoot('auth');
        }
      }
    }
  }

  back() {
    this._location.back();
  }
}
